import React from "react";
import "./Solution.css";

const features = [
  {
    number: "01",
    title: "Get More Customers with AI Automation",
    description:
      "AI chatbots reply instantly, answer questions, and capture leads — so you never miss a potential customer again.",
  },
  {
    number: "02",
    title: "Keep 100% of What You Earn",
    description:
      "Stop paying huge commissions to delivery apps and middlemen. Your platform, your customers, your profits",
  },
  {
    number: "03",
    title: "Share Your Business in One Tap",
    description:
      "Tap your NFC card and instantly share your contact, website, or profile. No apps, no typing, no lost connections.",
  },
  {
    number: "04",
    title: "Track Everything from One Dashboard",
    description:
      " See orders, leads, customers, and performance in real time. Clear insights that help you grow faster.",
  },
];

export default function Solution() {
  return (
    <section className="bb-section mainclass">
      <div className="maxwidth">
        <div className="bb-header">
          <p className="bb-solve">The BusinessBay Solution</p>
          <h1 className="bb-headline heading">
           Everything Your Business 
            <br />
           Needs to Manage, Market, and Grow.
          </h1>
          <p className="bb-subtext">
           Managing multiple tools is slowing you down. BusinessBay brings everything under one roof for faster growth.
          </p>
        </div>

        <div className="bb-grid">
          {features.map((feature) => (
            <div className="bb-card" key={feature.number}>
              <div className="bb-card-number">{feature.number}</div>
              <h3 className="bb-card-title">{feature.title}</h3>
              <p className="bb-card-desc">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
